module.exports = __webpack_public_path__ + "img/no_image.b74d8b0d.jpeg";